<template><div><h1 id="verkaufsstatistik-nach-medien-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#verkaufsstatistik-nach-medien-export-fur-excel"><span>Verkaufsstatistik nach Medien, Export für Excel</span></a></h1>
<p>Verkaufsstatistik nach Medien, Export für Excel — Liste der verkauften Artikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit detaillierten Informationen über alle verkauften Artikel (Auswertung der Auftragspositionen, der V-Partien und der offenen Bestellungen), die zum eingegebenen Mediumcode gehören und im gewählten Zeitraum [Erfassungsdatum von - bis] verkauft wurden. Es wird bei jedem Artikel Anzahl und Wert diverser Kennzahlen für jeden einzelnen Lagerort gezeigt. Die ausgewiesene &quot;Gesamtnachfrage&quot; ist die Summe aller Auftragspositionen (inkl. retournierte Artikel) für das gewählte Medium, die gewählten Lager und den gewählten Zeitraum.</p>
<p>Pfad:</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Mediumcode</dt>
<dd>Mediumcode, mit Kommas trennen, mit ! ausschliessen, * = alles</dd>
<dt>Lager</dt>
<dd>Lagernummer, mit Kommas trennen, mit ! ausschliessen, * = alles</dd>
<dt>Erfassungsdatum von</dt>
<dd>Erfassungsdatum der Faktura, leer = unbegrenzt</dd>
<dt>Erfassungsdatum bis</dt>
<dd>Erfassungsdatum der Faktura, leer = unbegrenzt</dd>
<dt>Ausgabe</dt>
<dd>Standard (Text- oder HTML-Datei)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>PM</td>
<td>Productmanager</td>
</tr>
<tr>
<td>Artikel-Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Artikel-Typ</td>
<td>Artikeltyp</td>
</tr>
<tr>
<td>Artikel-Nummer</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>EKPreis Wert</td>
<td>Einkaufspreis des Artikels aus Artikelstamm</td>
</tr>
<tr>
<td>VKPreis Wert</td>
<td>Verkaufspreis des Artikels aus Artikelstamm</td>
</tr>
<tr>
<td>Nafra-Lag. Stück</td>
<td>Anzahl pro Lagerort [Anzahl Gesamtnachfrage] - [Anzahl verkaufte Artikel pro Lager]</td>
</tr>
<tr>
<td>Nafra-Lag. Wert</td>
<td>Wert pro Lagerort [Wert Gesamtnachfrage] - [Wert des Lagerbestandes]</td>
</tr>
<tr>
<td>Geliefert-Lag. Stück</td>
<td>Anzahl &quot;gelieferte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Geliefert-Lag. Wert</td>
<td>Wert &quot;gelieferte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Retour-Lag. Stück</td>
<td>Anzahl &quot;retournierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Retour-Lag. Wert</td>
<td>Wert &quot;retournierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Ausverk.-Lag. Stück</td>
<td>Anzahl &quot;ausverkaufte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Ausverk.-Lag. Wert</td>
<td>Wert &quot;ausverkaufte&quot; Artikel pro Lager</td>
</tr>
<tr>
<td>Reserv.-Lag. Stück</td>
<td>Anzahl &quot;reservierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Reserv.-Lag. Wert</td>
<td>Wert &quot;reservierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Vorres.-Lag. Stück</td>
<td>Anzahl &quot;vorreservierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>Vorres.-Lag. Wert</td>
<td>Wert &quot;vorreservierte&quot; Artikel pro Lagerort</td>
</tr>
<tr>
<td>V-Part.-Lag. Stück</td>
<td>Anzahl &quot;verkaufbare&quot; Artikel pro Lagerort Auswertung der VPartien</td>
</tr>
<tr>
<td>V-Part.-Lag. Wert</td>
<td>Wert &quot;verkaufbare&quot; Artikel pro Lagerort Auswertung der VPartien</td>
</tr>
<tr>
<td>Effektiv Lager-Lag. Stück</td>
<td>Anzahl &quot;verfügbare&quot; Artikel pro Lagerort, [verkaufbare Artikel] - [reservierte Artikel] Auswertung V-Partien</td>
</tr>
<tr>
<td>Effektiv Lager-Lag. Wert</td>
<td>Wert &quot;verfügbare&quot; Artikel</td>
</tr>
<tr>
<td>Orderb.-Lag. Stück</td>
<td>Anzahl &quot;bestellte&quot; Artikel pro Lagerort Auswertung Offene Bestellungen</td>
</tr>
<tr>
<td>Orderb.-Lag. Wert</td>
<td>Wert &quot;bestellte&quot; Artikel pro Lagerort Auswertung Offene Bestellungen</td>
</tr>
<tr>
<td>Lagerb. Stück</td>
<td>Aktueller Artikelbestand in Stück des Artikels aus allen Lagerorten</td>
</tr>
<tr>
<td>Lagerb. Wert</td>
<td>Aktueller Artikelbestand in Franken des Artikels aus allen Lagerorten</td>
</tr>
<tr>
<td>Engag. Stück</td>
<td>Aktueller Artikelbestand + Orderbestand aus allen Lagerorten in Stück</td>
</tr>
<tr>
<td>Engag. Wert</td>
<td>Aktueller Artikelbestand + Orderbestand aus allen Lagerorten in Franken</td>
</tr>
</tbody>
</table>
</div></template>


